<template>
  <div>
    <b-card-code class="mt-2 principal">
      <validation-observer ref="rolValidation">
        <b-form @submit.prevent>
          <b-row class="mt-1 mb-1">
            <b-col md="6">
              <b-form-group label-for="mc-codigo">
                <label>Código: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Codigo"
                  rules="required"
                >
                  <b-form-input
                    id="mc-codigo"
                    v-model="codigo"
                    placeholder="Código"
                    :state="errors.length > 0 ? false : null"
                    name="codigo"
                    maxlength="10"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="mc-nombre">
                <label>Nombre: <span class="text-danger">*</span></label>
                <validation-provider
                  #default="{ errors }"
                  name="Nombre"
                  rules="required"
                >
                  <b-form-input
                    id="mc-nombre"
                    v-model="nombre"
                    placeholder="Nombre"
                    :state="errors.length > 0 ? false : null"
                    name="nombre"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label-for="mc-descripcion">
                <label>Descripción: </label>
                <validation-provider #default="{ errors }" name="Descripcion">
                  <b-form-input
                    id="mc-descripcion"
                    v-model="descripcion"
                    placeholder="Descripción"
                    name="descripcion"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 btn-guardar"
                size="sm"
                @click="validationForm"
              >
                <feather-icon
                  icon="SaveIcon"
                  size="16"
                  class="align-text-top"
                />
                <span>&nbsp;Guardar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-code>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code";
import { required, integer } from "@validations";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import es from "vee-validate/dist/locale/es.json";
import actions from "@/assets/utils/utils";
import $ from "jquery";
import Vue from "vue";

localize({
  es,
});

localize("es");

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      login_user: "",

      codigo: "",
      nombre: "",
      descripcion: "",
      token: "",

      required,
      integer,
    };
  },
  mounted() {
    if (this.$route.params.token) {
      this.token = this.$route.params.token;
      this.getRol();
    } else {
      console.log("NO ENTRO");
    }
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  methods: {
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("usu_rol_registrar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    getRol() {
      axios
        .post("api", {
          query: `query getRol($token: String!){
                    getRol(tokenRol:$token){
                        rol{
                            token,
                            codigo,
                            nombre,
                            descripcion
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            token: this.$route.params.token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getRol.status === "success") {
              const datos = response.data.data.getRol.rol;
              this.codigo = datos.codigo;
              this.nombre = datos.nombre;
              this.descripcion = datos.descripcion;
              actions.setearTitulo(this.codigo);
            } else {
              this.$router.push({ name: "error-404" });
            }
          }
        });
    },
    validationForm() {
      this.$refs.rolValidation.validate().then((success) => {
        if (success) {
          this.saveRol();
        }
      });
    },
    saveRol() {
      actions.bloquearBoton();
      axios
        .post("api", {
          query: `mutation createRol($codigo: String!, $nombre: String!, $descripcion: String!, $tokenRol: String!){
                    createRol(codigo: $codigo, nombre: $nombre, descripcion: $descripcion, tokenRol: $tokenRol)
                    {
                        rol{
                            token
                        }
                        message,
                        status,
                    }
                }`,
          variables: {
            codigo: this.codigo,
            nombre: this.nombre,
            descripcion: this.descripcion,
            tokenRol: this.token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.createRol.status === "success") {
              const token = response.data.data.createRol.rol.token;
              this.token = token;
              this.showToast();
              actions.setearTitulo(this.codigo);
              if (this.$route.params.token) {
                console.log("");
              } else {
                this.$router.push({ name: "editrol", params: { token } });
              }
            } else {
              this.$swal({
                title: "Error",
                text: response.data.data.createRol.message,
                icon: "error",
                confirmButtonColor: "#089599",
              });
            }
          }
          actions.desbloquearBoton();
        });
    },
    showToast() {
      this.$toast.success(
        {
          component: ToastificationContent,
          props: {
            title: "Rol",
            icon: "InfoIcon",
            text: "Se ha guardado con éxito un rol.",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
</style>
